import Ringtone from '../../resources/ringtone.mp3';
import SoundController from './SoundController';

const sound = new SoundController(Ringtone);
export default sound;